import {
  tag_styles_default
} from "./chunk.5DPYJIRK.js";
import {
  component_mobile_styles_default
} from "./chunk.3DO35SD7.js";
import {
  r
} from "./chunk.4JTBA2KG.js";

// src/components/tag/tag.styles.ts
var tag_styles_default2 = r` ${tag_styles_default} ${component_mobile_styles_default} .tag--secondary { background-color: var(--sl-color-secondary-50); color: var(--sl-color-secondary-800); border-color: var(--sl-color-secondary-200); } .tag--tertiary { background-color: var(--sl-color-tertiary-50); color: var(--sl-color-tertiary-800); border-color: var(--sl-color-tertiary-200); } .tag--text { border: none; } `;

export {
  tag_styles_default2 as tag_styles_default
};
